var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVControlUnmuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.434 11.1A1 1 0 0124 12v16a1 1 0 01-1.624.78L17.65 25H13a1 1 0 01-1-1v-8a1 1 0 011-1h4.65l4.726-3.78a1 1 0 011.058-.12zM28.907 24.67l-2.081-1.318a.282.282 0 00-.228-.032.29.29 0 00-.105.057.322.322 0 00-.077.097l-.376.714a.349.349 0 00.11.45l2.082 1.318a.28.28 0 00.332-.025.321.321 0 00.077-.097l.376-.713a.35.35 0 00-.11-.451zm-2.493-8.146c.02.037.046.07.077.096a.29.29 0 00.222.067.284.284 0 00.11-.041l2.082-1.318a.349.349 0 00.11-.45l-.374-.713a.321.321 0 00-.077-.096.275.275 0 00-.333-.025L26.15 15.36a.328.328 0 00-.14.2.359.359 0 00.03.251l.374.712zm3.284 2.73h-2.416c-.166 0-.302.15-.302.331v.828c0 .182.136.33.302.33h2.416c.166 0 .302-.148.302-.33v-.828c0-.182-.136-.33-.302-.33z",
    fill: "#fff"
  })));
}

export default SvgVControlUnmuted;